import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const CompassPage = lazy(() => import('src/pages/compass/list'));
const CompassEditPage = lazy(() => import('src/pages/compass/edit'));
const CompassAddPage = lazy(() => import('src/pages/compass/add'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const compassRoutes = [
  {
    path: 'compass',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <CompassPage />, index: true },
      { path: 'list', element: <CompassPage /> },
      { path: ':id/edit', element: <CompassEditPage /> },
      { path: 'create', element: <CompassAddPage /> },
    ],
  },
];
